import instance from "../../connection/instanceBlob";
import _unique from 'lodash/uniqueId';

function blobToFile(theBlob, fileName){       
  return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
}

const useImages = () => {
  const fetch = async (id, params) => {
    const { data } = await instance.get(`/api/image/${id}`, { params });

    const blobData = new Blob([data], {
      type: 'application/octet-stream'
   });

    return blobToFile(blobData, _unique() + '.jpeg')
  }

  const upload = async (params) => {
    const { data } = await instance.post('/api/image/upload', { params });

    const blobData = new Blob([data], {
      type: 'application/octet-stream'
   });

    return blobData
  }

  return [
    {},
    {
      fetch,
      upload
    }
  ]
}

export default useImages;
